import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
    className?: string;
};

const PromotedBadge = ({ className }: Props) => (
    <StyledPromotedBadge className={className}>
        <FormattedMessage id="featured" />
    </StyledPromotedBadge>
);

export default React.memo<Props>(PromotedBadge);

const StyledPromotedBadge = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    padding: 0 5px;
    background-color: ${({ theme }) => theme.colors.grey500};
`;
